/**
 * # Tracking store
 * > Manage our tracking events && install && init
 *
 * @TODO:
 *  - add more third party libs ?
 *  - add more prefilled actions...
 *
 * @author Kevin Bastien <kevin@kffein.com>
 */
//  import { each } from 'lodash';
import { createGtm, /* useGtm */ } from '@gtm-support/vue-gtm';
import { DEBUG, client, getEnv } from 'config';
import { defineStore } from 'pinia';
import { pinia } from 'plugins/store/index';
import { /* watch, */ computed, ref } from 'vue';

// add declaration for gtag
declare global { interface Window { gtag:any } }

type Consents = {
  necessary: true
  marketing: boolean
  preferences: boolean
  statistics: boolean
}
interface ITrackingStore extends Obj {
  client?: any,
  consents: Consents,
}

const useStore = defineStore('tracking', () => {
  const state = ref<ITrackingStore>({
    client: {
      gtm: undefined,
      ga: undefined,
    },
    consents:{
      necessary: true,
      marketing: DEBUG || false,
      preferences: DEBUG || false,
      statistics: DEBUG || false
    }
  });

  //actions
  const EVENT = (event:string, action:string, opts:any) => {
    // gtm track event
    if (state.value.client.gtm && window.dataLayer) {
      window.dataLayer.push({
        'event': event,
        ...opts
      });
    }
    // ga track event
    else if (state.value.client.ga && window.gtag) {
      window.gtag(event, action, opts);
    }
  }

  const INSTALL = (router: any) => {
    const plugins: Array<any> = [];

    // skip install if not client
    if (!client) return plugins;

    // install GTM
    if (getEnv('VITE_GTM_TRACKING_CODE') && getEnv('VITE_GTM_TRACKING_CODE') !== 'GTM-XXXXXX-XX') {
      const queryParams:any = {};

      // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
      if (getEnv('VITE_GTM_PREVIEW')
          && getEnv('VITE_GTM_AUTH')
          && getEnv('VITE_GTM_AUTH') !== 'X0xXX0XXXXxXxxXxXX0xxX') {
        queryParams.gtm_auth = getEnv('VITE_GTM_AUTH');
        queryParams.gtm_preview = getEnv('VITE_GTM_PREVIEW');
        //   gtm_cookies_win: 'x'
      }

      const gtm = createGtm({
        id: getEnv('VITE_GTM_TRACKING_CODE'), // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
        queryParams,
        defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
        compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
        // nonce: '2726c7f26c', // Will add `nonce` to the script tag
        enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
        debug: false, // Whether or not display console logs debugs (optional)
        loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
        ignoredViews: [], // Don't trigger events for specified router names (optional)
        trackOnNextTick: true // Whether or not call trackView in Vue.nextTick
      })
      state.value.client.gtm = true;
      plugins.push({ 
        install: gtm, 
        opts: null
      });
    }

    const onConsentUpdate = updateConsents();
    //@ts-expect-error
    window.addEventListener('CookiebotOnAccept', onConsentUpdate, false);
    //@ts-expect-error
    window.addEventListener('CookiebotOnDecline', onConsentUpdate, false);


    return plugins;
  }

  const updateConsents = () => {
    if (!window.Cookiebot?.consent) return
    const { necessary, marketing, preferences, statistics } = window.Cookiebot.consent as Consents
    // console.log(window.Cookiebot.consent);
    state.value.consents = {necessary, marketing, preferences, statistics}
  }

  return {
    state,

    //getters
    consents: computed(() => state.value.consents),

    //actions
    EVENT,
    INSTALL,
  }
});

export const store = useStore(pinia);
export default store;

//  /** Watch cookie consent answer */
//  watch(
//   ()=>cookieStore.status,
//   (status:any) => { 
    
//     // gtm thingy
//     if (getEnv('VITE_GTM_TRACKING_CODE')) {
//       const gtm = useGtm();
//       if (status === 'allow' && gtm) {
//         gtm.enable(true);
//       } else if (gtm) {
//         gtm.enable(false);
//       }

//     }
//   },
//   { immediate:true }
// )
